import React from "react";

const Footer = () => {
        return (
            <footer className="app-footer">
                <div className="d-flex flex-row justify-content-between">
                    <span> &copy;BeDaddy 2018 1.0.0</span>
                </div>
            </footer>
        );
    }
;

export default Footer;



// WEBPACK FOOTER //
// ./components/Footer/index.js